import React, { useRef, useState } from "react"
import * as S from "./join-the-team-form.styles"
import { Container, FormControl, Typography } from "@mui/material"
import Grid from "@mui/material/Grid"
import parse from "html-react-parser"
import CustomButton from "../../components/custom-button/custom-button.component"
import { useForm } from "react-hook-form"
import CustomTextField from "../../components/custom-text-field/custom-text-field.component"
import CustomCheckbox from "../../components/custom-checkbox/custom-checkbox.component"
import { contactFormApi, mediaApi } from "../../apis/contact-api"
import { getWordpressToken } from "../../utils"

const JoinTheTeamForm = ({}) => {
  const { register, handleSubmit, errors, control } = useForm({
    mode: "onBlur",
    reValidateMode: "onBlur",
  })

  const [isLoading, setIsLoading] = useState(false)
  const [successMessage, setSuccessMessage] = useState("")
  const [CVLink, setCVLink] = useState("")

  const handleUploadFile = async e => {
    if (e.target && e.target.files) {
      setIsLoading(true)
      const token = await getWordpressToken()
      const formData = new FormData()

      formData.append("file", e.target.files[0])
      const response = await mediaApi.post(`/wp/v2/media`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          accept: "application/json",
        },
      })

      if (response.data.source_url) {
        setCVLink(response.data.source_url)
        setIsLoading(false)
      }
    }
  }

  const onSubmit = async data => {
    setIsLoading(true)

    const positions = `${data.pizzaMakers ? data.pizzaMakers : ""} ${
      data.cooks ? data.cooks : ""
    } ${data.prep ? data.prep : ""} ${data.dishWasher ? data.dishWasher : ""} ${
      data.cashiers ? data.cashiers : ""
    } ${data.serverFoodRunner ? data.serverFoodRunner : ""} ${
      data.media ? data.media : ""
    } ${data.intern ? data.intern : ""}`
    const cvLink = "some link"

    const form = new FormData()
    form.append("firstName", data.firstName)
    form.append("lastName", data.lastName)
    form.append("yourEmail", data.email)
    form.append("phone", data.phone)
    form.append("positions", positions)
    form.append("othersPositions", data.othersText)
    form.append("yourCV", CVLink)
    const token = await getWordpressToken()

    return await contactFormApi
      .post("/757/feedback", form, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then(response => {
        setIsLoading(false)
        if (response?.data?.message) {
          setSuccessMessage(response.data.message)
        } else {
          setSuccessMessage("Please try again later!")
        }
      })
  }

  return (
    <S.Wrapper>
      <Container>
        <S.FormWrapper>
          <form onSubmit={handleSubmit(onSubmit)}>
            {isLoading && (
              <S.FormSpinner>
                <S.CustomSpinner />
              </S.FormSpinner>
            )}
            {!successMessage ? (
              <>
                <S.Title>Job Application</S.Title>
                <S.InputWrapper>
                  <S.Label>*First Name</S.Label>
                  <CustomTextField
                    type="text"
                    name="firstName"
                    isRequired
                    errors={errors}
                    register={register}
                  />
                </S.InputWrapper>
                <S.InputWrapper>
                  <S.Label>*Last Name</S.Label>
                  <CustomTextField
                    type="text"
                    name="lastName"
                    isRequired
                    register={register}
                    errors={errors}
                  />
                </S.InputWrapper>
                <S.InputWrapper>
                  <S.Label>*Email Address</S.Label>
                  <CustomTextField
                    type="email"
                    name="email"
                    isRequired
                    register={register}
                    errors={errors}
                  />
                </S.InputWrapper>
                <S.InputWrapper>
                  <S.Label>*Mobile Phone</S.Label>
                  <CustomTextField
                    type="text"
                    name="phone"
                    isRequired
                    register={register}
                    errors={errors}
                  />
                </S.InputWrapper>
                <S.PositionsTitle>
                  <S.Label>*Positions</S.Label>
                  <S.Line />
                </S.PositionsTitle>
                <Grid container>
                  <Grid item xs={6} md={4}>
                    <S.CheckboxWrapper>
                      <CustomCheckbox
                        label="Pizza Makers"
                        name="pizzaMakers"
                        value="Pizza Makers,"
                        register={register}
                      />
                    </S.CheckboxWrapper>
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <S.CheckboxWrapper>
                      <CustomCheckbox
                        label="Cooks"
                        name="cooks"
                        value="Cooks,"
                        register={register}
                      />
                    </S.CheckboxWrapper>
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <S.CheckboxWrapper>
                      <CustomCheckbox
                        label="Prep"
                        name="prep"
                        value="Prep,"
                        register={register}
                      />
                    </S.CheckboxWrapper>
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <S.CheckboxWrapper>
                      <CustomCheckbox
                        label="Dish Washers"
                        name="dishWasher"
                        value="Dish Washers,"
                        register={register}
                      />
                    </S.CheckboxWrapper>
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <S.CheckboxWrapper>
                      <CustomCheckbox
                        label="Cashiers"
                        name="cashiers"
                        value="Cashiers,"
                        register={register}
                      />
                    </S.CheckboxWrapper>
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <S.CheckboxWrapper>
                      <CustomCheckbox
                        label="Server / Food Runner"
                        name="serverFoodRunner"
                        value="Server / Food Runner,"
                        register={register}
                      />
                    </S.CheckboxWrapper>
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <S.CheckboxWrapper>
                      <CustomCheckbox
                        label="Media"
                        name="media"
                        value="Media,"
                        register={register}
                      />
                    </S.CheckboxWrapper>
                    <S.ListWrapper>
                      <ul>
                        <li>Social Media</li>
                        <li>Videographer</li>
                        <li>Photographer</li>
                      </ul>
                    </S.ListWrapper>
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <S.CheckboxWrapper>
                      <CustomCheckbox
                        label="Intern"
                        name="intern"
                        value="Intern"
                        register={register}
                      />
                    </S.CheckboxWrapper>
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <S.CheckboxWrapper>
                      <CustomCheckbox
                        label="Others"
                        name="others"
                        value="Others"
                        register={register}
                      />
                    </S.CheckboxWrapper>
                    <S.TextAreaWrapper>
                      <S.TextArea
                        rows="4"
                        cols="50"
                        name="othersText"
                        ref={register}
                      />
                    </S.TextAreaWrapper>
                  </Grid>
                </Grid>
                <S.PositionsTitle>
                  <S.Label>Upload Resume</S.Label>
                  <S.Line />
                  <S.GridWrapper>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={7}>
                        <S.InfoWrapper>
                          <S.FileInput
                            accept=".doc,.docx,.pdf"
                            multiple
                            name="fileCV"
                            type="file"
                            onChange={handleUploadFile}
                          />
                        </S.InfoWrapper>
                      </Grid>
                      <Grid item xs={12} md={5}>
                        <S.InfoWrapper>
                          <S.TypeText>
                            Accepted file types: doc, docx, pdf, Max. file size:
                            3 MB.
                          </S.TypeText>
                        </S.InfoWrapper>
                      </Grid>
                    </Grid>
                  </S.GridWrapper>
                </S.PositionsTitle>
                <S.Label>Privacy Protection</S.Label>
                <S.Line />
                <S.PrivacyText>
                  {parse(
                    "<strong>The Ventur 66 LLC</strong> is committed to protecting your online privacy. All information you supply is for our internal review only. It will never be shared or sold to any other organization or used for any other purposes."
                  )}
                </S.PrivacyText>
                <S.Button className="red" type="submit">
                  Send Request
                </S.Button>
              </>
            ) : (
              <S.SuccessMessage>
                <Typography>{successMessage}</Typography>
              </S.SuccessMessage>
            )}
          </form>
        </S.FormWrapper>
      </Container>
    </S.Wrapper>
  )
}

export default JoinTheTeamForm
